/**
 * Insurance Companies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageCompaniesComponent,
  AsyncAddCompanyComponent,
  AsyncModifyCompanyComponent,
  AsyncSetPricesComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageCompaniesComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddCompanyComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyCompanyComponent}
      />
      <Route
        path={`${match.url}/set-prices`}
        component={AsyncSetPricesComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
